import { createContext } from 'react';
var businessTypeDetails = {
  'Business Type': [{
    description: '',
    id: '',
    name: ''
  }]
};
var defaultState = {
  businessTypeData: businessTypeDetails
};
var BusinessTypeDetailsContext = /*#__PURE__*/createContext(defaultState);
export { BusinessTypeDetailsContext, businessTypeDetails };